import { GetProfileResponse } from '@features/user/types/get-profile-response';
import ReactGA from 'react-ga4';

/** The SPA's `app` value in GA, as a user property and on events. */
export const GA_APP = 'Max Member';
/** Members are the only users of the SPA; Rails sends the same value. */
export const GA_USER_TYPE = 'Member';

/** Attach the member's GA user properties to every later hit. */
export function setGaUserProperties(profile: GetProfileResponse) {
  if (!import.meta.env.VITE_GOOGLE_ANALYTICS_PROPERTY_ID || !ReactGA.gtag) {
    return;
  }
  try {
    ReactGA.gtag('set', 'user_properties', {
      app: GA_APP,
      businessUser: profile.businessUser,
      memberLevel: profile.memberLevel,
      onboardingStatus: profile.onboardingStatus,
      sharedWithAdvisor: profile.sharedWithAdvisor,
      userType: GA_USER_TYPE,
      partner: profile.partner?.uuid,
    });
  } catch {
    // Analytics must never get in the way: the chromeless loader calls this,
    // and a throw there would show the error page instead of the wizard.
  }
}
